module.exports = __webpack_public_path__ + "img/2.af6c488c.png";